/**
 * ABテスト設定オブジェクト
 * @typedef {Object} ABTestConfig
 * @property {string} testName - テスト名
 * @property {number} bPatternRatio - Bパターンの割合（0-100）。bPatternRangeを指定した場合は無視されます。
 * @property {[number, number]} bPatternRange - Bパターンとなる範囲（[start, end]）。指定時はbPatternRatioは不要です。
 * @property {boolean} enable - ABテストを有効にするかどうか
 */

// フッタータブABテストの定義
export const FOOTER_TAB_AB_TEST_NAME = 'FOOTER_TAB_AB_TEST'
export const SEARCH_AND_EVENT_DETAIL_AB_TEST_NAME = 'SEARCH_AND_EVENT_DETAIL'
export const TOP_FV_V3_AB_TEST_NAME = 'TOP_FV_V3_AB_TEST'

/**
 * フッタータブABテスト設定
 * @type {ABTestConfig}
 */
export const FOOTER_TAB_AB_TEST_CONFIG = {
  testName: FOOTER_TAB_AB_TEST_NAME,
  bPatternRatio: 30, // 30% B pattern (非表示), 70% A pattern (表示)
  enable: false
}

export const SEARCH_AND_EVENT_DETAIL_AB_TEST_CONFIG = {
  testName: SEARCH_AND_EVENT_DETAIL_AB_TEST_NAME,
  bPatternRatio: 20,
  enable: false
}

export const EVENT_TITLE_AB_TEST_NAME = 'EVENT_TITLE_AB_TEST'

/**
 * イベントタイトルABテスト設定
 * @type {ABTestConfig}
 */
export const EVENT_TITLE_AB_TEST_CONFIG = {
  testName: EVENT_TITLE_AB_TEST_NAME,
  bPatternRatio: 50, // 50% B pattern (短いタイトル), 50% A pattern (長いタイトル)
  enable: false
}

export const TOP_FV_V3_AB_TEST_CONFIG = {
  testName: TOP_FV_V3_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（新機能適用）
  enable: false // テスト有効
}

// 回数券A/Bテストの定義
export const REPEAT_DISCOUNT_AB_TEST_NAME = 'REPEAT_DISCOUNT_AB_TEST'

/**
 * 回数券A/Bテスト設定
 * @type {ABTestConfig}
 */
export const REPEAT_DISCOUNT_AB_TEST_CONFIG = {
  testName: REPEAT_DISCOUNT_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（回数券モーダル表示）、70% Aパターン（コントロール：表示なし）
  enable: false // テストを有効にする
}

export const CLS_MONITORING_AB_TEST_NAME = 'CLS_MONITORING_TEST'
export const CLS_MONITORING_AB_TEST_CONFIG = {
  testName: CLS_MONITORING_AB_TEST_NAME,
  bPatternRatio: 10, // 10% B pattern (monitoring enabled)
  enable: true
}

export const TOP_FV_V4_AB_TEST_NAME = 'TOP_FV_V4_AB_TEST'
export const TOP_FV_V4_AB_TEST_CONFIG = {
  testName: TOP_FV_V4_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（新KV）、70% Aパターン（現行）
  enable: false // ABテストを有効化（false に変更してテストを無効にできます）
}

// issue390: エリアトップバナー表示/非表示ABテストの定義
export const ISSUE_390_AB_TEST_NAME = 'ISSUE_390_AB_TEST_V2'

/**
 * issue390: エリアトップバナー表示/非表示ABテスト設定
 * @type {ABTestConfig}
 */
export const ISSUE_390_AB_TEST_CONFIG = {
  testName: ISSUE_390_AB_TEST_NAME,
  bPatternRatio: 50, // 50% Bパターン（バナー非表示）、50% Aパターン（バナー表示）
  enable: false // ABテストを無効化
}

/**
 * ISSUE402（こだわり条件）A/Bテスト設定
 * bPatternRangeを指定した場合はbPatternRatioは不要です。
 * 同じtestNameを使うことで、他のABテスト（例: ISSUE395）も同じCookie値で判定できます。
 * @type {ABTestConfig}
 */
export const ISSUE_402_AND_395_AB_TEST_NAME = 'ISSUE_402_AND_395_AB_TEST'

export const ISSUE402_AB_TEST_CONFIG = {
  testName: ISSUE_402_AND_395_AB_TEST_NAME,
  bPatternRange: [33, 65], // 33~65がB群
  enable: false
}

export const FLOATING_BUTTON_AB_TEST_CONFIG = {
  testName: ISSUE_402_AND_395_AB_TEST_NAME,
  bPatternRatio: 100,
  enable: true
}

// issue-434: ai_recommend_v3 ABテスト設定
export const ISSUE_434_AB_TEST_NAME = 'ISSUE_434_AB_TEST'

/**
 * issue-434: ai_recommend_v3 ABテスト設定
 * A群(従来ロジック群): 来訪SSの70%
 * B群(新規ロジック群): 来訪SSの30%
 * @type {ABTestConfig}
 */
export const ISSUE_434_AB_TEST_CONFIG = {
  testName: ISSUE_434_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（ai_recommend_v3）、70% Aパターン（従来ロジック）
  enable: true
}

/**
 * issue-400: 新規来訪者向けクーポンABテスト設定
 */
export const FIRST_VIEW_GUEST_COUPON_AB_TEST_NAME = 'FIRST_VIEW_GUEST_COUPON_AB_TEST'
export const FIRST_VIEW_GUEST_COUPON_AB_TEST_CONFIG = {
  testName: FIRST_VIEW_GUEST_COUPON_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（新規訪問クーポンモーダル表示）、70% Aパターン（コントロール：表示なし）
  enable: true // テストを有効にする
}

// Payment flow ABテストの定義（issue-403）
export const ISSUE_403_PAYMENT_FLOW_AB_TEST_NAME = 'ISSUE_403_PAYMENT_FLOW_AB_TEST'

/**
 * Payment flow ABテスト設定
 * Aパターン: 既存の購入フロー（purchase_options → guest_purchases/new）
 * Bパターン: 新しい統合購入フロー（1ページで完結）
 * @type {ABTestConfig}
 */
export const ISSUE_403_PAYMENT_FLOW_AB_TEST_CONFIG = {
  testName: ISSUE_403_PAYMENT_FLOW_AB_TEST_NAME,
  bPatternRatio: 50, // 50% Bパターン（新フロー）、50% Aパターン（既存フロー）
  enable: true // テスト有効化
}
